import React, { useState } from "react";
import "./DataLibrary.scss";
import { DataLibrarySourceItem } from "./DataLibrarySourceItem";
import { Paginator } from "primereact/paginator";
import {
  IAllSourcesApi,
  parametersPaginationSources,
  useGetAllSourcesQuery,
} from "../../cdsApiSlice";
import { Message } from "primereact/message";
import { RenderLoading } from "../sourceExterne/DataSourceExterneDetail";

interface Props {
  search: string;
  ascendingSort: boolean;
}

export const DataLibrarySourcesList = ({
  search,
  ascendingSort,
}: Props) => {
  const [pagination, setPagination] = useState<parametersPaginationSources>({
    page: 0,
    size: 10,
    field: "nom",
    search: search,
    sort: ascendingSort ? "asc" : "desc",
  });
  const { data: sources, ...SourcesStatus } = useGetAllSourcesQuery(pagination);



  const DataLibraryRow = (sources: IAllSourcesApi) => {
    let rows = [];

    for (let i = 0; i < sources.data.length; i++) {
      rows.push(
        <div className="m-1">
          <DataLibrarySourceItem
            key={sources.data[i].id}
            id_source_externe={sources.data[i].id}
            name={sources.data[i].nom}
            kind={"source"}
            description={sources.data[i].description}
            icon={sources.data[i].icon}
            source_protocle={
              sources.data[i]?.metadonnees.find(
                (i: any) => i.nom === "source_protocole"
              )?.valeur
            }
            type_espace_de_stockage={
              sources.data[i]?.espacesDeStockage[0]?.type
            }
            nom_espace_de_stockage={sources.data[i]?.espacesDeStockage[0]?.nom}
            sourceExterne={sources.data[i]}
          />
        </div>
      );
    }
    return <div>{rows}</div>;
  };

  const paginate = (event: any) => {
    setPagination({
      ...pagination,
      page: event.first / event.rows,
      size: event.rows,
    });
  };

  return (
    <div className="surface-ground">
      {SourcesStatus.isFetching && <RenderLoading />}
      {SourcesStatus.isError && (
        <div className="m-5">
          <Message
            className="w-full"
            severity="error"
            text="Erreur de chargement des sources externes"
          />
        </div>
      )}
      {sources && !SourcesStatus.isFetching && (
        <>
          <div className="flex mt-3" style={{ width: "100%" }}>
            <div className="flex mr-3" />
            <div className="flex mr-3">{DataLibraryRow(sources)}</div>
          </div>
          <div style={{ alignItems: "center" }}>
            <Paginator
              first={pagination.page * pagination.size}
              rows={pagination.size}
              totalRecords={sources.total}
              onPageChange={paginate}
              className={"surface-ground"}
            ></Paginator>
          </div>
        </>
      )}
    </div>
  );
};
